var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Store"},[(_vm.res)?_c('VendorCreate',{attrs:{"vid":_vm.vendor_id,"rate":_vm.rate_enable,"video":_vm.video_enable,"back":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }